import React from 'react';
import { Award, Calendar } from 'lucide-react';
import { AboutStory } from './AboutStory';
import { ABOUT_VALUES } from '../data/siteContent';

const PHOTOS = [
  {
    src: 'https://customer-assets.emergentagent.com/job_image-to-site-34/artifacts/ou9dfo0u_1000002086.jpeg',
    alt: 'Young Johnnie Mayo - The Original Bow Tie Guy',
    icon: Calendar,
    badge: 'Class of 1977',
    title: 'The Original',
    subtitle: 'Where the journey began',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_image-to-site-34/artifacts/rt10eo2f_1000001921.webp',
    alt: 'Johnnie Mayo Today - The Bow Tie Guy',
    icon: Award,
    badge: 'Present Day',
    title: 'The Master',
    subtitle: 'Decades of excellence',
  },
];

const About = () => (
  <section id="about" className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12 sm:mb-16">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-[#001B2A] mb-4">
          Meet Johnnie L Mayo
        </h2>
        <p className="text-xl sm:text-2xl font-serif text-[#7B1E2B] mb-2">
          The Bow Tie Guy
        </p>
        <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
          A lifelong journey of style, elegance, and timeless fashion
        </p>
      </div>

      {/* Then & Now Photos */}
      <div className="mb-16">
        <h3 className="text-2xl sm:text-3xl font-serif font-bold text-[#001B2A] text-center mb-8">
          Then & Now: A Journey Through Time
        </h3>
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {PHOTOS.map(({ src, alt, icon: Icon, badge, title, subtitle }) => (
            <div key={title} className="relative group">
              <div className="relative rounded-lg overflow-hidden shadow-2xl">
                <img src={src} alt={alt} className="w-full h-[400px] sm:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-6 left-6 right-6 text-white">
                  <div className="flex items-center gap-2 mb-2">
                    <Icon className="h-5 w-5" />
                    <p className="text-sm font-medium">{badge}</p>
                  </div>
                  <p className="text-2xl font-serif font-bold">{title}</p>
                  <p className="text-sm mt-1">{subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <AboutStory />

      {/* Values */}
      <div className="grid sm:grid-cols-3 gap-8">
        {ABOUT_VALUES.map(({ icon: Icon, title, description }) => (
          <div key={title} className="text-center p-6 sm:p-8 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#E6D7B3] rounded-full mb-4">
              <Icon className="h-8 w-8 text-[#001B2A]" />
            </div>
            <h3 className="text-xl font-serif font-bold text-[#001B2A] mb-3">{title}</h3>
            <p className="text-gray-600">{description}</p>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="mt-16 text-center">
        <div className="bg-gradient-to-r from-[#001B2A] to-[#7B1E2B] rounded-lg p-8 sm:p-12 text-white">
          <h3 className="text-2xl sm:text-3xl font-serif font-bold mb-4">
            Ready to Elevate Your Style?
          </h3>
          <p className="text-lg mb-6 max-w-2xl mx-auto">
            Let Johnnie help you find the perfect bow tie that tells your story
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="inline-block bg-white text-[#001B2A] px-8 py-4 rounded-md font-semibold hover:bg-[#E6D7B3] transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            GET IN TOUCH
          </button>
        </div>
      </div>
    </div>
  </section>
);

export default About;
